<template>
  <div class="Ftim-box" v-if="infolist">
    <div class="Ftim-bt">
      <span>至德-</span>第一时间
      <i></i>
    </div>

    <div class="">
      <div class="Ftim-top">
        <div class="Ftim-current">
          <em></em>当前位置：<span><router-link :to="{path:'/'}">首页</router-link> -- <router-link :to="{path:'ftime'}">第一时间</router-link> -- </span> 文章
        </div>
      </div>
    </div>

    <div class="Ftiminfo-cent">
      <div class="Ftiminfo-title">{{infolist.title}}</div>
      <div class="Ftiminfo-time" v-if="infolist.updated_at">发布日期：{{infolist.updated_at}}</div>
      <div class="Ftiminfo-info" v-html="infolist.content"></div>
    </div>
   
  </div>
</template>
<script>
export default {
  data() {
    return {
      setid:'',        //传过来的id
      infolist:[]
    };
  },
  created(){
    this.setid = this.$route.query.id;
    this.getData();
  },
  mounted() {
  },
  methods: {

    //获取详情数据
    getData(){
      this.$layer.loading();
      this.$http.get('detail/'+this.setid).then((res)=>{
        if(res.data.code == 200){
          this.$layer.closeAll('loading');
          this.infolist = res.data.data;
        }else{
          this.$layer.msg(res.data.message);
        }
      })
    },
  },
};
</script>
<style scoped>
  .Ftim-box{
    background: url(../../../public/images/dysjbjt.png) top no-repeat;
    margin-bottom: 60px;
  }
  .Ftim-bt{
    width: 1200px;
    margin: 72px auto 0;
    font-weight: bold;
    font-size: 48px;
    color: #333;
    line-height: 48px;
  }
  .Ftim-bt span{
    color: #D71E1C;
  }
  .Ftim-bt i{
    display: block;
    width: 48px;
    height: 4px;
    background: #D71E1C;
    margin-top: 30px;
  }
  .Ftim-top{
    width: 1200px;
    height: 74px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #FFFFFF;
    border-radius: 20px 20px 0px 0px;
    margin: 74px auto 0;
  }
  .Ftim-current{
    line-height: 74px;
    font-size: 16px;
    color: #333;
  }
  .Ftim-current em{
    display: inline-block;
    width: 12px;
    height: 12px;
    background: linear-gradient( 139deg, #ED403C 0%, #D71E1C 100%), #D8D8D8;
    border-radius: 50%;
    margin: 0 10px 0 20px;
  }
  .Ftim-current span{
    color: #999;
  }
  .Ftim-current a{
    color: #999;
  }

  .Ftim-fanhui{
    width: 20px;
    height: 20px;
    margin-right: 30px;
    background: url(../../../public/images/fanhui.png) right center no-repeat;
    background-size: 20px 20px;
    cursor: pointer;
  }

  .Ftiminfo-cent{
    width: 1140px;
    margin: 40px auto 0;
    padding: 0 30px;
  }
  .Ftiminfo-title{
    text-align: center;
    font-weight: bold;
    font-size: 32px;
    color: #333333;
    line-height: 32px;
  }
  .Ftiminfo-time{
    font-size: 16px;
    color: #999999;
    font-weight: 400;
    text-align: center;
    margin-top: 20px;
  }
  .Ftiminfo-info{
    margin-top: 22px;
  }
</style>